const STATUS_TO_DECISION = {
  action_required: "Action Required",
  referred: "Action Required",
  needs_action: "Action Required",

  awaiting_response: "Awaiting Response",
  awaiting: "Awaiting Response",
  awaiting_review: "Awaiting Response",

  approved: "Approved",
  completed: "Approved",

  declined: "Declined",
  rejected: "Declined",
  failed: "Declined",
};

export const getDecision = (status) => {
  const normalizedStatus = String(status || "")
    .toLowerCase()
    .trim();
  return STATUS_TO_DECISION[normalizedStatus] || "Unknown";
};

export default getDecision;
